import {useState} from 'react';
import cn from 'classnames';

import CardCheckbox from '@/root/components/CardCheckbox';
import {HomeCardWithTitle} from '@/root/models/home';

interface Props {
  card: HomeCardWithTitle;
  selectedCardIds: Set<string>;
  onChangeSelectedCards: (cardIds: Set<string>) => void;
}

const CardGroupCheck = ({card, selectedCardIds, onChangeSelectedCards}: Props) => {
  const hasGroup = card.groupedCards.length > 1;
  const checked = card.groupedCards.every(({cardId}) => selectedCardIds.has(cardId));
  const isExpired = card.groupedCards.every(({expired}) => expired);
  const [isExpanded, setExpanded] = useState(false);

  const onChangeCheckbox = () => {
    if (checked) {
      card.groupedCards.forEach((card) => selectedCardIds.delete(card.cardId));
    } else {
      card.groupedCards.forEach((card) => selectedCardIds.add(card.cardId));
      hasGroup && setExpanded(true);
    }
    onChangeSelectedCards(selectedCardIds);
  };

  return (
    <li className={cn('item_g item_check', {type_expired: isExpired})} role="listitem">
      <input type="checkbox" name="listItems" className="inp_g" checked={checked} onChange={onChangeCheckbox} />
      <div className="wrap_lab">
        <span className="icon icon_input"></span>
        <span className="thumb_item" style={{backgroundImage: `url(${card.thumbnailUrl})`}}></span>
        <span className="item_list" aria-hidden="true">
          <strong className="txt_list">
            <span className="txt_item">{card.title}</span>
            {hasGroup && <span className="txt_count">외 {card.groupedCards.length - 1}개</span>}
            {isExpired && (
              <>
                <span className="dot_desc">,</span> <span className="txt_red">만료</span>
              </>
            )}
          </strong>
          <span className="txt_desc">{card.subTitle}</span>
        </span>
        {hasGroup && (
          <button
            type="button"
            className="btn_accordion"
            aria-expanded={isExpanded}
            onClick={() => setExpanded(!isExpanded)}
          >
            <span className="icon icon_arr_down_type4"></span>
          </button>
        )}
      </div>
      {hasGroup && (
        <div className={cn('cont_sub', isExpanded && 'show')} role="region">
          <div className="group_check">
            <div className="group_item group_choice">
              {card.groupedCards.map((card) => (
                <CardCheckbox
                  key={card.cardId}
                  card={card}
                  selectedCardIds={selectedCardIds}
                  onChangeSelectedCards={onChangeSelectedCards}
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </li>
  );
};

export default CardGroupCheck;
